import { useDispatch, useSelector } from "react-redux";
import { COURSES_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { deleteCoursesAction } from "../../../redux/actions/coursesActions";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import { useState } from "react";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { MdOutlineEventAvailable } from "react-icons/md";
import { MdPublishedWithChanges } from "react-icons/md";

const NotificationCard = ({ data }) => {
  const navigate = useNavigate();

  const title = data.title === "event" ? "Tədbir var" : "Yeniləmə var";
  const date = moment(data.createdAt)
    .tz("Asia/Baku")
    .format("DD.MM.YYYY HH:mm");
  let content;

  if (data.title === "event") {
    const eventDate = `${moment(data.event.date)
      .tz("Asia/Baku")
      .format("DD.MM.YYYY")} ${data.event.time}`;
    content = `${eventDate} tarixində, ${data.event.place} adlı məkanda ${data.event.eventName} adlı tədbir keçiriləcək`;
  } else if (data.title === "updates") {
    if (data.type === "sent-updates-to-confirm") {
      if (data.history.modelName === "student") {
        content = (
          <>
            <strong>@{data.history.oldData.fullName}</strong> adlı tələbə
            məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən
            yenilənərək təsdiq üçün göndərildi
          </>
        );
      }
    } else if (data.type === "update-directly") {
      if (data.history.modelName === "student") {
        content = (
          <>
            <strong>@{data.history.oldData.fullName}</strong> adlı tələbə
            məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən
            yeniləndi
          </>
        );
      } else if (data.history.modelName === "tuition-fee") {
        content = (
          <>
            <strong>@{data.history.oldData.student.fullName}</strong> adlı
            tələbənin <strong>{data.history.oldData.group.name}</strong>{" "}
            qrupundakı təhsil haqqı məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən
            yeniləndi
          </>
        );
      } else if (data.history.modelName === "group") {
        content = (
          <>
            <strong>@{data.history.oldData.name}</strong> adlı qrup məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən
            yeniləndi
          </>
        );
      }
    } else if (data.type === "delete") {
      if (data.history.modelName === "student") {
        content = (
          <>
            <strong>@{data.history.oldData.fullName}</strong> adlı tələbə
            məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən silindi
          </>
        );
      } else if (data.history.modelName === "group") {
        content = (
          <>
            <strong>@{data.history.oldData.name}</strong> adlı qrup məlumatları
            <strong> @{data.history.sender.fullName}</strong> tərəfindən silindi
          </>
        );
      }
    }
  }

  const navigateToUpdates = () => {
    if (data.title === "updates" && data.history.documentId) {
      if (data.history.modelName === "student") {
        navigate(`/updates/${data.history.documentId}/student`);
      } else if (data.history.modelName === "tuition-fee") {
        navigate(
          `/updates/${data.history.documentId}/tuition-fee?groupId=${data.history.groupId}`
        );
      } else if (data.history.modelName === "group") {
        navigate(`/updates/${data.history.documentId}/group`);
      }
    }
  };

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: "12px 16px",
        marginBottom: "12px",
        borderRadius: "8px",
        backgroundColor: data.isView ? "#f5f5f5" : "#d2e9ff",
        cursor: "pointer",
      }}
      onClick={navigateToUpdates}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "8px",
        }}
      >
        {data.title === "event" && (
          <MdOutlineEventAvailable style={{ fontSize: "20px" }} />
        )}
        {data.title === "updates" && (
          <MdPublishedWithChanges style={{ fontSize: "20px" }} />
        )}
        <p
          style={{
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {title}
        </p>
      </div>
      <p style={{ fontSize: "16px", margin: "10px 0" }}>{content}</p>
      <p style={{ fontSize: "13px" }}>{date}</p>
    </div>
  );
};

export default NotificationCard;
